module.exports = __webpack_public_path__ + "img/small-4.4a12f600.jpg";